// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'SSS pension upload'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#tab-upload" data-toggle="tab">
          <span>File upload</span>
        </a>
      </li>
      <li>
        <a data-target="#tab-results" data-toggle="tab" >
          <span>Results</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="tab-content">
    <div class="tab-pane active" id="tab-upload">
      <batch-sss-pension-upload on-submit="\$ctrl.gotoUploadResult">
      </batch-sss-pension-upload>
    </div>

    <div class="tab-pane" id="tab-results">
      <batch-sss-pension-result-list
        summary="\$ctrl.summary"
      >
      </batch-sss-pension-result-list>
    </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/sss-pension/batch-sss-pension.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;